import context from '@truckdown/components-systems';
import { IUserManager, UpdateUserInfoModel, UserModel } from "@truckdown/accounts";
import { defineComponent, ref, Ref, computed, onMounted } from "vue";
import { isGeneralAdmin, showMessage } from "../../../Utilities/Utilities";
import validationError from "../../../Validation/Error/Error.vue";
import { UserValidator } from "../../Validation/UserValidator";

interface IData {
    isLoading: Ref<boolean>,
    userValidator: Ref<any>,
    userProfile: Ref<UserModel>,
    updateModel: Ref<UpdateUserInfoModel>
};

const getInitialData = function (props: any) {

    var update = {
        id: props.userProfile.id,
        firstName: props.userProfile.firstName,
        lastName: props.userProfile.lastName,
        office: props.userProfile.phones?.office ?? undefined,
        fax: props.userProfile.phones?.fax ?? undefined,
        home: props.userProfile.phones?.home ?? undefined
    } as UpdateUserInfoModel;

    return {
        isLoading: ref<boolean>(false),
        userValidator: ref<any>(new UserValidator(props.userProfile)),
        userProfile: ref<UserModel>(props.userProfile),
        updateModel: ref<UpdateUserInfoModel>(update)
    } as IData;
}

const getMethods = function (props: any, data: IData, ctx: any) {
    return {
        editUserInfoCancelClick: function (): void {
            ctx.emit(userCancelEventName);
        },
        editUserInfoSaveClick: async function (): Promise<void> {
            await saveUser(data, props, ctx);
        }
    }
}

const isUserValid = function (data: IData): boolean {
    data.userValidator.value = new UserValidator(data.updateModel.value);
    return data.userValidator.value.validate();
}

const saveUser = async function (data: IData, props: any, ctx: any): Promise<void> {
    if (!data.isLoading.value && isUserValid(data)) {
        data.isLoading.value = true;

        try {
            let userManager = await context.getService<IUserManager>('IUserManager');

            var response = await userManager.updateInfo(data.updateModel.value);

            if (!response || !response.ok) {
                showMessage("Error updating user info.", "danger", true, true);
            } else {
                showMessage("User Info was succssfully updated.", "success", true, true);
                ctx.emit(userUpdatedEventName, response.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            data.isLoading.value = false;
        }
    }
}

const userUpdatedEventName = 'update';
const userCancelEventName = 'cancel';

export default defineComponent({
    props: {
        userProfile: {
            type: Object as () => UserModel,
            required: true
        }
    },
    components: {
        'error': validationError,
    },
    emits: [userUpdatedEventName, userCancelEventName],
    setup: function (props, ctx) {
        let data = getInitialData(props);
        let methods = getMethods(props, data, ctx);

        return {
            ...data,
            ...computed,
            ...methods,
        };
    }
});